import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function AddNewMedia() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    link: "",
    mediafile: null,
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files : value,
    }));
  };

  const handleAddMedia = async (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("title", formData.title);
    data.append("link", formData.link);

    if (formData.mediafile) {
      data.append("mediafile", formData.mediafile[0]);
    }

    try {
      const response = await axios.post(
        `${config.BASE_URL}/api/admin/add-media`,
        data,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        navigate("/admin/medias");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add media");
    }
  };

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>

        <div className="main-section">
          <div className="back_btn_wrap">
            <button
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
          </div>

          <div className="main-inner add_project_main">
            <form
              onSubmit={handleAddMedia}
              encType="multipart/form-data"
            >
              <div className="form-login">

                {/* Title */}
                <div className="add_field">
                  <h2>Media Title</h2>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Video Link */}
                <div className="add_field">
                  <h2>Video Link</h2>
                  <input
                    type="url"
                    name="link"
                    value={formData.link}
                    onChange={handleInputChange}
                    placeholder="https://abc.com/..."
                    // required
                  />
                </div>

                {/* Thumbnail / Video Upload */}
                <div className="add_field">
                  <h2>Media File</h2>

                  <div className="file-upload">
                    <input
                      type="file"
                      name="mediafile"
                      onChange={handleInputChange}
                      required
                    />
                    <i className="fa fa-camera i-pic-upload"></i>
                  </div>
                </div>

              </div>

              <div className="add_project">
                <button type="submit">
                  Add Media
                </button>
              </div>
            </form>

            {error && (
              <p className="error-message">{error}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewMedia;